class MCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerInner = this.querySelector('.g-cart-drawer__inner');
    this.cartDrawerCloseIcon = this.querySelector('.g-cart-drawer__close');
    this.cartOverlay = this.querySelector('.g-cart__overlay');
    this.rootUrl = window.Shopify.routes.root;

    this.setHeaderCartIconAccessibility();
    this.cartDrawerCloseIcon.addEventListener('click', this.close.bind(this));
    this.addEventListener('click', (event) => {
      if (event.target.closest('.g-cart-drawer__inner') !== this.cartDrawerInner) {
        this.close();
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('.g-cart-icon-bubble');
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        if (GkifySettings.enable_cart_drawer) {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.classList.add('g-cart-drawer--active');
    requestAnimationFrame(() => {
      this.style.setProperty('--g-bg-opacity', '0.5');
      this.cartDrawerInner.style.setProperty('--translate-x', '0');
    });
    window.GkifyEvents.emit(GkifyTheme.pubSubEvents.openCartDrawer);
    document.documentElement.classList.add('prevent-scroll');
  }

  close() {
    this.style.setProperty('--g-bg-opacity', '0');
    this.cartDrawerInner.style.setProperty('--translate-x', '100%');
    setTimeout(() => {
      this.classList.remove('g-cart-drawer--active');
      document.documentElement.classList.remove('prevent-scroll');
    }, 300);
  }

  renderContents(parsedState) {
    this.classList.contains('g-cart--empty') && this.classList.remove('g-cart--empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    setTimeout(() => {
      this.open();
    });
  }

  updateCartCount(itemCount) {
    const cartCounts = document.querySelectorAll('.g-cart-count-bubble');
    cartCounts.forEach((cartCount) => {
      if (itemCount > 0) {
        cartCount.textContent = itemCount;
        cartCount.classList.remove('g:hidden');
      } else {
        cartCount.classList.add('g:hidden');
      }
    });
  }

  getCart() {
    return fetchJSON(this.rootUrl + 'cart.json');
  }

  onCartDrawerUpdate(updateFooter = true) {
    fetch(`${GkifySettings.routes.cart}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        this.getSectionsToRender().forEach((section) => {
          if (section.block === 'cart-items') {
            const sectionElement = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
          } else {
            if (updateFooter) {
              const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
              sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
            }
          }
        });
      })
      .catch((e) => {
        console.error(e);
      });
    this.getCart().then((cart) => {
      this.classList.toggle('g-cart--empty', cart.item_count === 0);
      this.updateCartCount(cart.item_count);
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '[data-gkify-cart-items]',
        block: 'cart-items',
      },
      {
        id: 'cart-drawer',
        selector: '[data-gkify-cart-items-new]',
        block: 'cart-items',
      },
      {
        id: 'cart-drawer',
        selector: '[data-gkify-cart-discounts]',
        block: 'cart-footer',
      },
      {
        id: 'cart-drawer',
        selector: '[data-cart-subtotal]',
        block: 'cart-footer',
      },
      {
        id: 'cart-drawer',
        selector: '[data-gkify-gift-wrapping]',
        block: 'cart-footer',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('g-cart-drawer', MCartDrawer);

class MCartDrawerItems extends MCartTemplate {
  getSectionsToRender() {
    return [
      {
        id: 'GkifyCartDrawer',
        section: 'cart-drawer',
        selector: '[data-gkify-cart-items]',
      },
      {
        id: 'GkifyCartDrawer',
        section: 'cart-drawer',
        selector: '[data-gkify-cart-items-new]',
      },
      {
        id: 'GkifyCartDrawer',
        section: 'cart-drawer',
        selector: '[data-gkify-cart-discounts]',
      },
      {
        id: 'GkifyCartDrawer',
        section: 'cart-drawer',
        selector: '[data-cart-subtotal]',
      },
      {
        id: 'GkifyCartDrawer',
        section: 'cart-drawer',
        selector: '[data-gkify-gift-wrapping]',
      },
    ];
  }
}

customElements.define('g-cart-drawer-items', MCartDrawerItems);
